
export enum NoticeTargetType {
  Organization,
  Destination,
  PassengerGroup,
  Passenger
}

export interface IRideitNoticeTarget {
  id: string | null;
  noticeId: string | null;
  targetType: NoticeTargetType;
  organizationId?: string | null;
  destinationId?: number | null;
  passengerGroupId?: number | null;
  passengerId?: number | null;
}

export class RideitNoticeTarget implements IRideitNoticeTarget {
  id: string | null;
  noticeId: string | null;
  targetType: NoticeTargetType;
  organizationId?: string | null;
  destinationId?: number | null;
  passengerGroupId?: number | null;
  passengerId?: number | null;

  constructor(data?: IRideitNoticeTarget | null) {
    this.id = data?.id ?? null;
    this.noticeId = data?.noticeId ?? null;
    this.targetType = data?.targetType ?? NoticeTargetType.Organization;
    this.organizationId = data?.organizationId ?? null;
    this.destinationId = data?.destinationId ?? null;
    this.passengerGroupId = data?.passengerGroupId ?? null;
    this.passengerId = data?.passengerId ?? null;
  }

  toCreateRequest() {
    return {
      targetType: this.targetType,
      organizationId: this.organizationId,
      destinationId: this.destinationId,
      passengerGroupId: this.passengerGroupId,
      passengerId: this.passengerId
    } as IRideitNoticeTargetCreateRequest;
  }
}

export interface IRideitNoticeTargetCreateRequest {
  targetType: NoticeTargetType;
  organizationId?: string | null;
  destinationId?: number | null;
  passengerGroupId?: number | null;
  passengerId?: number | null;
}